export function formFieldValid(field, type, fieldName, required) {
  let validation = {
    valid: false,
    reason: null,
  }

  if (!required && !field) {
    validation.valid = true
    return validation
  }

  if (!field || field.length < 1) {
    validation.reason = `Please enter a valid ${fieldName}.`
    return validation
  }

  if (type === 'fullname') {
    const splitName = field.split(' ')
    if (splitName.length !== 2) {
      validation.reason = `Please enter a valid first and last name.`
      return validation
    }
    if (!/^[a-zA-Z]+$/i.test(splitName[0])) {
      validation.reason = `First name should only contain letters.`
      return validation
    }
    if (!/^[a-zA-Z]+$/i.test(splitName[1])) {
      validation.reason = `Last name should only contain letters.`
      return validation
    }
    if (splitName[2]) {
      validation.reason = `Please only enter first and last name.`
      return validation
    }
  }
  if (type === 'firstName') {
    if (!field) {
      validation.reason = `Please enter a valid first name.`
      return validation
    }
    if (!/^[a-zA-Z]+$/i.test(field)) {
      validation.reason = `First name should only contain letters.`
      return validation
    }
  }

  if (type === 'lastName') {
    if (!field) {
      validation.reason = `Please enter a valid last name.`
      return validation
    }
    if (!/^[a-zA-Z]+$/i.test(field)) {
      validation.reason = `Last name should only contain letters.`
      return validation
    }
  }

  if (type === 'email') {
    const emailRegex =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    if (!emailRegex.test(field)) {
      validation.reason = `${fieldName} is not valid.`
      return validation
    }
  }

  if (type === 'phone') {
    if (field.length !== 10) {
      validation.reason = `${fieldName} should only be 10 digits long.`
      return validation
    }
    if (/[a-z]/i.test(field)) {
      validation.reason = `${fieldName} should only contain numbers.`
      return validation
    }
  }

  validation.valid = true
  return validation
}

export default formFieldValid
